import { useState } from "react";
import {
  SearchContainer,
  Title,
  OptionCard,
  RadioInput,
  OptionTitle,
  OptionSubtitle,
  SearchRow,
  InputWrapper,
  Input,
  AtSymbol,
  SearchIconDiv,
  FindButton
} from "./InstagramAccountSearch.styled";
import { SearchIcon } from "../../../../Common/SvgIcon/CommonSvgIcons";


export default function InstagramAccountSearch({ mode, setMode, handleChange, searchQuery, setSearchQuery, handleSearch }) {

  const handleModeChange = (val) => {
    setMode(val)
    setSearchQuery("")
  }

  const handleClick = () => {
    if(searchQuery){
      handleSearch()
    }
    
  }

  return (
    <SearchContainer>
      <Title>What would you like to do?</Title>

      <OptionCard active={mode === "recommandation"}>
        <RadioInput
          type="radio"
          checked={mode === "recommandation"}
          onChange={() => handleModeChange("recommandation")}
        />
        <div>
          <OptionTitle>Discover accounts by keyword</OptionTitle>
          <OptionSubtitle>
            Find multiple accounts related to a brand or topic
          </OptionSubtitle>
          {
            mode === "recommandation" &&
            <SearchRow>
              <InputWrapper>
                <Input value={searchQuery} onChange={handleChange} />
                <SearchIconDiv>{SearchIcon}</SearchIconDiv>
              </InputWrapper>
              <FindButton onClick={handleClick}>Find</FindButton>
            </SearchRow>
          }

        </div>
      </OptionCard>

      <OptionCard active={mode === "exact"}>
        <RadioInput
          type="radio"
          checked={mode === "exact"}
          onChange={() => handleModeChange("exact")}
        />
        <div>
          <OptionTitle>Find an exact Instagram account</OptionTitle>
          <OptionSubtitle>
            Search using a specific username
          </OptionSubtitle>

          {
            mode === "exact" &&
            <SearchRow>
              <InputWrapper>
                <Input value={searchQuery} onChange={handleChange} />
                <SearchIconDiv>{SearchIcon}</SearchIconDiv>
              </InputWrapper>
              <FindButton onClick={handleClick}>Find</FindButton>
            </SearchRow>
          }

        </div>
      </OptionCard>
    </SearchContainer>

  );
}
